import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader
} from "semantic-ui-react";
import ButtonHandler from "../../ButtonHandler.jsx";
import processIcon from "../../../Images/process.png";
import config from "../../../config.js";
const storageBaseUrl = config["storage_base_url"];
import excel from "../../../Images/excel_icon.png";
import CheckboxTable from "../CheckboxView.jsx";
import { fetchAutomationStatusData, runSmartspotAutomationScript, fetchUseraction, 
    getDisbursementFormulas, updateDisbursementFormulas, fetchTemplates, 
    getWorkingFiles,rawFileProcess,getsplittedFiles,getSplitFilesFormulas,
    updateSplitFileFormulas,
    processApprovedFiles,
    splitSitewiseProcess,
    sendWorkingFiles,
    processCreditNote,
    sendCreditNoteFiles
} from '../../../actions/users_action';

var apiTimeout = null
class GilletteBin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            automationStatus: 'Pending',
            initial: true,
            outputUrl: '',
            downloadEnable: false,
            templateId: "",
            distributors: [],
            selectedDistributor: '',
            formulaModalOpen: false,
            formulas: [],
            selectedTemplate: '',
            templates: [],
            automationSplitFiles:[],
            modalOpen:false,
            fileUploaded: false,
            fileName: '',
            currentFile: {},
            workingFiles:[],
            auditingSplit:[],
            nonAuditingSplit:[],
            formulasType:'',
            loaderStatus:false,
            selectedDist:{},
            disType:'Smartspot'
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'], fileTemplates: res.templates[res.templates.length - 1]['fileTemplates'] })
            },
            onFailure: () => {
            }
        })

    }

    start = () => {
        // this.setState({
        //     automationStatus: 'Processing',
        //     initial: false
        // })

        // apiTimeout = setTimeout(this.loadData, 3000)

        // let data = {
        //     templateId:this.state.templateId
        // }

        // this.props.runSmartspotAutomationScript(data,{
        //     onSuccess: () => {

        //     },
        //     onFailure: () => {

        //     }
        // })
    }

    loadData = () => {
        this.props.fetchAutomationStatusData(this.state.templateId,{
            onSuccess: (res) => {
                if (res.automation_status.length > 0) {
                    res.automation_status.map((d) => {
                        if (d.file && d.file == 'FinalOutput' && d.disbursementType == 'Smartspot' && d.fileUploadStatus == 'Completed') {
                            this.setState({ automationStatus: d.fileUploadStatus, downloadEnable: true })
                            clearTimeout(apiTimeout)
                        }
                    })
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadData, 3000)
    }

    downloadfile = (url) => {
        window.open(url);
    }

    dropDownDistributorOnChange = (e, data) => {
        this.setState({ selectedDistributor: data.value })
    }

    dropDownTemplateOnChange = (e, data) => {
        data.options.map((d)=>{
            if(d.value == data.value){
                this.setState({templateId:d.key})
                this.props.fetchUseraction(
                    d.key,
                    {
                        onSuccess: (res) => {
                            this.setState({ distributors: res.users })
                        },
                        onFailure: () => { this.setState({ loading: false }) }
                    });
                 this.props.getWorkingFiles(
                    d.key,this.state.disType,
                    {
                    onSuccess:(res)=>{
                        this.setState({automationSplitFiles:res.workingFiles})
                        let workingFiles = []
                        res.workingFiles.map((d)=>{
                            if(d.fileType == 'Workings'){
                                workingFiles.push(d)
                            }
                            else if(d.fileType == 'Smartspot Workings'){
                                workingFiles.push(d)
                            }
                        })
                        this.setState({workingFiles:workingFiles})
                    },
                    onFailure:()=>{
                    }
                })
                this.props.getsplittedFiles(
                    d.key,
                    {
                    onSuccess:(res)=>{
                        this.setState({auditingSplit:res.auditingFiles,nonAuditingSplit:res.nonAuditingFiles})
                    },
                    onFailure:()=>{
                    }
                })

                this.props.fetchAutomationStatusData(
                    d.key,
                    {
                    onSuccess: (res) => {
                        if (res.automation_status.length > 0) {
                            res.automation_status.map((d) => {

                                if (d.file && d.fileUploadStatus && d.fileUploadStatus=='Completed'&& d.disbursementType == 'Smartspot' && d.file == 'FinalOutput') {
                                    this.setState({ outputUrl: d.finalOutputUrl,automationStatus: d.fileUploadStatus,initial:false,downloadEnable:true })
                                }
                                else if (d.disbursementType == 'Smartspot' && d.file && d.file == 'FinalOutput' ) {
                                    this.setState({ automationStatus: d.fileUploadStatus, initial: false })
                                }
                            })
                        }
                        else{
                            this.setState({
                                outputUrl:'',
                                automationStatus:'Pending',
                                initial:true,
                                downloadEnable:false
                            })
                        }
                    },
                    onFailure: () => {
        
                    }
                })
            }
        })
        this.setState({ selectedTemplate: data.value })
    }

    closeFormulaModal = () => {
        this.setState({ formulaModalOpen: false })
    }

    formulasModal = (types) => {
        if(types == 'Main'){
            this.props.getDisbursementFormulas({
                onSuccess: (res) => {
                    let formulas_calc = res.data.formulas.slice(2, -2)
                    this.setState({ formulas: formulas_calc })
                },
                onFailure: () => {
    
                }
            })
            this.setState({formulasType: types,formulaModalOpen: true })
        }

        else {
            let data = {
                type:types
            }
            this.props.getSplitFilesFormulas(data,{
                onSuccess: (res) => {
                    let formulas_calc = res.formulas
                    this.setState({ formulas: formulas_calc })
                },
                onFailure: () => {
    
                }
            })
            this.setState({formulasType: types,formulaModalOpen: true })

        }
        
       
    }

    formulaOnChange = (e, data) => {
        let formulas_data = this.state.formulas;
        formulas_data.map((d) => {
            if (Object.keys(d)[0] == Object.keys(data)[0]) {
                d[Object.keys(d)[0]] = e.target.value + '\n'
            }
        })
        this.setState({ formulas: formulas_data })
    }

    saveFormulas = () => {
        let data = {
            formulas: this.state.formulas
        }
        let split_data = {
            formulas: this.state.formulas,
            type:this.state.formulasType
        }
        if(this.state.formulasType == 'Main'){
            this.props.updateDisbursementFormulas(data, {
                onSuccess: () => {
                    this.setState({ formulaModalOpen: false })
                    alert("Formulas File Updated")
                },
                onFailure: () => {
    
                }
            })
        }
        else{
            this.props.updateSplitFileFormulas(split_data, {
                onSuccess: () => {
                    this.setState({ formulaModalOpen: false })
                    alert("Formulas File Updated")
                },
                onFailure: () => {
    
                }
            })
        }
        
    }

    closeuploadoption = () =>{
        this.setState({modalOpen:false})
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    uploadRawFile = () => {
        this.props.rawFileProcess(this.state.currentFile, this.state.fileName, this.state.templateId, {
            onSuccess: () => {
                this.setState({ modalOpen: false })
                alert("File Uploaded Successfully")
            },
            onFailure: () => {

            }
        })
    }

    uploadFile = async (fileName, type) => {
        console.log(type,'type')
        this.setState({ fileName: fileName, fileType: type,modalOpen:true })
        
    }

    splitFiles = async()=>{
        let templateId = this.state.templateId;
        this.setState({loaderStatus:true})
        await this.props.splitSitewiseProcess(templateId,{
            onSuccess:()=>{
                this.setState({loaderStatus:false})
                this.props.getsplittedFiles(
                    this.state.templateId,
                    {
                    onSuccess:(res)=>{
                        this.setState({auditingSplit:res.auditingFiles,nonAuditingSplit:res.nonAuditingFiles})
                    },
                    onFailure:()=>{
                    }
                })
            }
        })
    }

    processApprovedFiles = () =>{
        let templateId = this.state.templateId
        this.setState({loaderStatus:true})
        this.props.processApprovedFiles(templateId,{
            onSuccess:()=>{
                this.setState({loaderStatus:false})
            },
            onFailure:()=>{

            }
        })
    }

    siteData = (rowData, checkedValue) => {
    
        this.setState({'selectedDist':rowData})
        
    };

    sendedData = (rowData, row) => {
        this.setState({'selectedDist':rowData})
    };

    releaseWorking = () =>{
        if(Object.keys(this.state.selectedDist).length !== 0){
            this.props.sendWorkingFiles(this.state.selectedDist,{
                onSuccess:()=>{
                    alert('Working Files Released Successfully')
                },
                onFailure:()=>{
    
                }
            })
        }
        else{
            alert('Please Select Distributor')
        }
        
    }

    processCreditNotes = () =>{
        if(Object.keys(this.state.selectedDist).length !== 0){
            if(this.state.selectedDist.dseClientUpdate != 'pending'){
                this.setState({loaderStatus:true})
                this.props.processCreditNote(this.state.selectedDist,{
                    onSuccess:()=>{
                        this.setState({loaderStatus:false})
                        alert('Credit Note Process Done')
                    },
                    onFailure:()=>{
                    }
                })
            }
            else{
                alert("DSE File Process Not Yet Done")
            }
        }
        else{
            alert('Please Select Distributor')
        }
    }

    releaseCreditNote =()=>{
        if(Object.keys(this.state.selectedDist).length !== 0){
            if(this.state.selectedDist.creditNoteStatus != 'pending'){
                this.props.sendCreditNoteFiles(this.state.selectedDist,{
                    onSuccess:()=>{
                        alert('Working Files Released Successfully')
                    },
                    onFailure:()=>{
        
                    }
                })
            }
            else{

            }
            
        }
        else{
            alert('Please Select Distributor')
        }
    }



    render() {

        var templateMonths = []

        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d.name,
                'text': d.name
            })
        })

        const auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "Smartspot Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.large)}
                    />;
                },
            },
            {
                Header: "Smartpsot DSE",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.dseLarge)}
                    />;
                },
            },
            {
                Header: "DSE Upload Status",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    if(original.dseClientUpdate == 'pending'){
                        return <Icon name="ban" style={{ marginLeft: 45, cursor: 'pointer' }} color={'orange'} 
                    />;
                    }
                    
                    else{
                        return <Icon name="check circle" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    />;
                    }
                },
            },
            {
                Header: "Credit Note Process Status",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    if(original.creditNoteStatus == 'pending'){
                        return <Icon name="ban" style={{ marginLeft: 45, cursor: 'pointer' }} color={'orange'} 
                    />;
                    }
                    
                    else{
                        return <Icon name="check circle" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    />;
                    }
                },
            },
            {
                Header: "Smartspot Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'} 
                    onClick={() => this.downloadfile(storageBaseUrl + original.creditNoteLarge)}
                    />;
                },
            }
        ];

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Dimmer active={this.state.loaderStatus}>
        <Loader size="massive">File Processing.....</Loader>
      </Dimmer>
                </div>

                {/* <br /> */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Template Month' search selection options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>

                </div>


                <Grid columns={3} style={{ marginTop: 20 }}>

                    <GridColumn>
                        <Card.Group>
                            <h2 style={{marginLeft: 10 }}>Final Disbursement Processing</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Description>
                                        <h4>{`Automation Status   `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <strong style={{ color: this.state.automationStatus == 'Completed' ? 'green' : this.state.automationStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.automationStatus}</strong></h4>
                                    </Card.Description>
                                    <br></br>

                                </Card.Content>
                                <Card.Content extra>

                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.initial == true && (
                                            <Button basic color='green'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="hand point up" />
                                                Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='green'
                                                onClick={() => this.downloadfile(storageBaseUrl + this.state.outputUrl)}
                                                disabled={this.state.downloadEnable == true ? false : true}
                                            >
                                                <Icon name="download" />
                                                Download
                                            </Button>
                                        )}

                                    </div>

                                </Card.Content>
                            </Card>

                        </Card.Group>
                    </GridColumn>
                    <GridColumn style={{ display: 'flex', flexDirection: 'row' }}>

                        <Card.Group>
                            <h2>Automation Result</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                     <br></br>
                                    <br></br>
                                    <br></br>
                                    <Card.Description style={{marginTop:20}}>
                                        <h3 style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>{`Automation Files  `}
                                        <Icon name="arrow circle down" style={{ marginLeft: 75, cursor: 'pointer' }} color={'green'}
                                        disabled={this.state.downloadEnable == true ? false : true} 
                                        onClick={() => this.downloadfile(storageBaseUrl + this.state.automationSplitFiles[0].result[0])}
                                        />
                                        <Icon name="pencil alternate" style={{  cursor: 'pointer' }} color={'green'} 
                                        onClick={() => this.formulasModal('NonAuditing - Large')}
                                        />
                                        </h3>
                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                        <br></br>

                    </GridColumn>
                    <GridColumn>
                        <Card.Group>
                            <h2>Approved Disbursement</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                     <br></br>
                                    <br></br>
                                    <br></br>
                                    <Card.Description style={{marginTop:20}}>
                                        <h3 style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>{'Approved Files  '} <Icon name="upload" style={{ marginLeft: 65, cursor: 'pointer' }} color={'orange'} 
                                        onClick={() => this.uploadFile('smartspotAuditing', 'smartspotAuditing')}
                                        /><Icon name="arrow circle down" style={{ marginLeft:25, cursor: 'pointer' }} color={'green'} 
                                        onClick={() => this.downloadfile(storageBaseUrl + this.state.workingFiles[0].result[0])}
                                        /></h3>
                                        
                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>
                </Grid>
                <br></br>
                <br></br>
                <div style={{display:'flex',flexDirection:'row'}}>
                    <div>
                    <p style={{ fontSize: 25 }}>
                        <h1
                            style={{

                                flex: "0 0 30px",
                                display: "inline-block",
                                color: "#2185d0",
                            }}
                        >
                            Disbursement Working for Sites
                        </h1>
                    </p>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                            size="large"
                            color="blue"
                            onClick={()=>this.processApprovedFiles()}
                        >

                            Process Approved Files
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                            size="large"
                            color="blue"
                            onClick={()=>this.splitFiles()}
                        >

                            Split Files
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                            size="large"
                            color="blue"
                            onClick={()=>this.releaseWorking()}
                        >

                            Release Workings
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                            size="large"
                            color="blue"
                            onClick={()=>this.processCreditNotes()}
                        >

                            Process CreditNote
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5,cursor:'pointer' }}
                            size="large"
                            color="blue"
                            onClick={()=>this.releaseCreditNote()}
                        >

                            Release CreditNote
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                 
                </div>
                
                    
                    <p style={{ fontSize: 18 }}>
                        <h1
                            style={{

                                flex: "0 0 30px",
                                display: "inline-block",
                                color: "#0000000",
                            }}
                        >
                            Site Wise Files
                        </h1>
                    </p>
                <CheckboxTable
                    data={this.state.auditingSplit}
                    columns={auditing_split_columns}
                    sendedData={this.siteData}
                />
                <br></br>
                <br></br>

                <Modal
                    open={this.state.formulaModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <strong>{`IF No formula for a column please specifiy the column as like "A -- No Formula"`}</strong>
                            {this.state.formulas.length > 0 && this.state.formulas.map((d) => {
                                return (
                                    <Grid columns={1}>
                                        <Grid.Row>
                                            <GridColumn style={{ marginTop: 20 }}>
                                                <Form.Input
                                                    type="any"
                                                    label={Object.keys(d)[0]}
                                                    value={Object.values(d)[0]}
                                                    onChange={(e) => this.formulaOnChange(e, d)}
                                                    placeholder={Object.values(d)[0]}
                                                />
                                            </GridColumn>
                                        </Grid.Row>
                                    </Grid>
                                )

                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveFormulas}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                
                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadRawFile}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>

            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchAutomationStatusData,
            runSmartspotAutomationScript,
            fetchUseraction,
            getDisbursementFormulas,
            updateDisbursementFormulas,
            fetchTemplates,
            getWorkingFiles,
            rawFileProcess,
            getsplittedFiles,
            getSplitFilesFormulas,
            updateSplitFileFormulas,
            processApprovedFiles,
            splitSitewiseProcess,
            sendWorkingFiles,
            processCreditNote,
            sendCreditNoteFiles
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GilletteBin));
